import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseGridComponent } from '@base/component/BaseGridComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, CredentialType, CredentialActivityStatus } from '@m4u-angular/base/entities/BaseEntities';
import { DateHelpers } from '@core/helpers/DateHelpers';
import { ContextMenuElement } from '@m4u-angular/base/classes/BaseClasses';

@Component({
    providers: ServiceBagServices,
    selector: 'app-credentialactivitystatus-grid',
    templateUrl: './credentials-activity-status-grid.component.html',
    styleUrls: ['./credentials-activity-status-grid.component.scss']
})
export class CredentialActivityStatusGridComponent extends BaseGridComponent<CredentialActivityStatus, BaseState>{
    @Input() CredentialsInfo: CredentialType[];
    @Output() OnRefresh = new EventEmitter<void>();

    constructor(A: ServiceBagService) {
        super(A, 'CredentialActivityStatusGridComponent', CredentialActivityStatus, BaseState);
    }

    OnGetLastUsedBeforeText(rowData): string {
        return DateHelpers.GetDateApproximate((rowData as CredentialActivityStatus).LastUseDate, false);
    }

    protected override GetGridRowContextMenu(options?: any): ContextMenuElement[] {
        return [{
            text: this.RC('btnGoToLoginHistory'),
            visible: true,
            onClick: () => this.OnGoToLoginHistory(options)
        }, {
            text: this.RC('btnGoToRequestsHistory'),
            visible: true,
            onClick: () => this.OnGoToRequestsHistory(options)
        }];
    }

    private OnGoToLoginHistory(options) {
        this.Navigate(['pages/general/credential-login-history'], { CredentialID: options.data.CredentialID });
    }

    private OnGoToRequestsHistory(options) {
        this.Navigate(['pages/general/requests-history'], { CredentialID: options.data.CredentialID });
    }

    OnToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            isCustom: true,
            options: {
                icon: 'refresh',
                onClick: () => {
                    this.OnRefresh.emit();
                }
            }
        });
    }
}
